
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tagDetails",
      function () {
        return require("private-next-pages/tagDetails/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tagDetails"])
      });
    }
  